/**
 * 文件说明: 系统配置
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 18/08/01
 */

import baseConfig from 'config/index'
import {dvaNamespacePrefix} from '../_hz-project/hz-project-common'

const config = require(`./${HUZAN_ENV}.js`).default

export default {
    dvaNamespacePrefix,
    apiHost: baseConfig?.apiHost ?? '',
    accessTokenKey: 'OEM_WORK_MANAGER_ADMIN_ACCESS_TOKEN_KEY',
    homePage: '/company-management/management',
    ...config,
}
